module.exports = __webpack_public_path__ + "img/emoticon-nps-0-on.f15522ee.svg";